const STATUS_IS_MANDATORY = 'Status is mandatory';
const NO_RECORDS_FOUND = 'No records found.';
const BU_IS_MANDATORY = 'BU is mandatory';
const ACCOUNT_SELECTION_IS_MANDATORY = 'Account selection is mandatory';
const FIRST_NAME_REQUIRED = 'First Name is mandatory';
const LAST_NAME_REQUIRED = 'Last Name is mandatory';
const EMAIL_FORMAT_INCORRECT = 'Email format is incorrect';
const EMAIL_IS_MANDATORY = 'Email is mandatory';
const GENERAL_FAILURE = 'Something went wrong. Please try again.';
const INVALID_DATE_FORMAT = 'Please enter date in MM/DD/YYYY format';
const PHONE_FORMAT = 'Phone format is incorrect';
export class LoginFormError {
  public static EmptyUserIdAndPassword = 'Please enter your Email address and Password.';
  public static EmptyUserId = 'Please enter your Email address.';
  public static IncorrectUserIdFormat = 'Please enter correct Email address.';
  public static EmptyPassword = 'Please enter your password.';
  public static IncorrectUserIdAndPassword = `The email address or password you entered is incorrect. For security reasons, your account may be temporarily locked after repeated failed attempts.`;
  public static UserInactive = `Your user account is currently inactive. Please contact your `;
  public static UserNotSubscribed = 'Unauthorized user. Please contact your ';
  public static ServerInactiveMessage = 'Account is inactive.';
  public static ServerAccountLocked = 'Account is Locked.';
  public static readonly AccountLockedMessage = `Too many failed attempts detected. To protect your account, access is temporarily restricted. Please try again later or use "Forgot your password" feature.`;
  public static readonly TooManyRequests = 'TooManyRequests';
}
export class OrderDynamicErrors {
  public static ImproperSepcimenCodeError = 'Please enter correct Specimen Source';
}
export class SetForgetPasswordError {
  public static emailBlank = 'Please enter your email address.';
  public static emailInvalid = 'Please enter valid email address.';
  public static emailNotPresent = 'An account could not be found with the provided email address.';
  public static allFieldsBlank = 'Below fields cannot be blank.';
  public static EmptyVerificationCode = 'Please enter verification code.';
  public static EmptyPasswordFields = 'Please enter password(s).';
  public static PasswordNotMatch = 'Please enter matching passwords.';
  public static PasswordPolicyRequirementError = 'Your passwords do not meet the password policy requirements.';
  public static InvalidCode = 'The verification code provided is incorrect / expired.';
  public static VerificationCodeNotSent = 'The email id does not exists or the verification code could not be sent.';
  public static ServerInactiveMessage = 'Account is inactive.';
  public static BadRequest = 'Bad Request. Please correct the input.';
  public static readonly TooManyRequests = 'TooManyRequests';
  public static readonly AccountLockedMessage = `Too many failed attempts detected. To protect your account, access is temporarily restricted.`;
}

export class CreateUpdateProfileFormError {
  public static ValidationsForCreateEditUser = {
    FIRST_NAME_MAX_LENGTH: 'Max length for first name is 50',
    FIRST_NAME_REQUIRED: FIRST_NAME_REQUIRED,
    LAST_NAME_MAX_LENGTH: 'Max length for last name is 50',
    LAST_NAME_REQUIRED: LAST_NAME_REQUIRED,
    TITLE_MAX_LENGTH: 'Max length for title is 75',
    MIDDLE_INITIAL_MAX_LENGTH: 'Max length for middle Initial is 1',
    EMAIL_MAX_LENGTH: 'Max length for email is 100',
    EMAIL_ALREADY_EXISTS: 'Email address already exists',
    EMAIL_FORMAT: EMAIL_FORMAT_INCORRECT,
    EMAIL_DOMAIN: 'Email must belong to eurofins/ radiantdelivers.com/ empowerDXlab.com/ clinicalenterprise.com domains',
    EMAIL_REQUIRED: EMAIL_IS_MANDATORY,
    WORK_PHONE_FORMAT: 'Work phone format is incorrect',
    FAX_NUMBER_FORMAT: 'Fax number format is incorrect',
    WORK_PHONE_REQUIRED: 'Work Phone is mandatory',
    STATUS_REQUIRED: STATUS_IS_MANDATORY,
    LINKED_ACCOUNT_REQUIRED: 'Atleast 1 Linked Account is mandatory',
    BU_ACCOUNT_REQUIRED: 'Atleast 1 Linked BU is mandatory',
    PERMISSION_REQUIRED: 'Atleast 1 permission is mandatory',
    USER_CREATION_SUCCESSFUL: 'User profile created successfully.',
    PROFILE_UPDATION_SUCCESSFUL: 'User profile updated successfully.',
    GENERAL_FAILURE: GENERAL_FAILURE,
    NO_RECORDS_FOUND: NO_RECORDS_FOUND,
    PUID_FORMAT: 'PUID must be alphanumeric with maxlength as 4 characters',
    PUID_REQUIRED: 'PUID is mandatory',
  };

  public static ReturnCreateEditUserErrors() {
    return this.ValidationsForCreateEditUser;
  }
}

export class CreateUpdateSpecimenFormError {
  public static ValidationsForCreateUpdateSpecimen = {
    SHORT_NAME_MAX_LENGTH: 'Max length for specimen short name is 50',
    SHORT_NAME_REQUIRED: 'Specimen Short Name is mandatory',
    FULL_NAME_MAX_LENGTH: 'Max length for specimen full name is 100',
    FULL_NAME_REQUIRED: 'Specimen Full Name is mandatory',
    UNIT_MAX_LENGTH: 'Max length for specimen unit is 75',
    UNIT_REQUIRED: 'Specimen Unit is mandatory',
    CODE_MAX_LENGTH: 'Max length for bu specimen code is 50',
    CODE_REQUIRED: 'BU Specimen Code is mandatory',
    STATUS_REQUIRED: STATUS_IS_MANDATORY,
    BU_REQUIRED: BU_IS_MANDATORY,
    SPECIMEN_ALREADY_ASSOCIATED_ERROR_MESSAGE: 'BU Specimen code already exists in our system.',
    SPECIMEN_SUCCESSFULL_CREATION_MESSAGE: 'Specimen Type Created Successfully',
    SPECIMEN_SUCCESSFULL_UPDATED_MESSAGE: 'Specimen Type Updated Successfully'
  };

  public static ReturnCreateUpdateSpecimenErrors() {
    return this.ValidationsForCreateUpdateSpecimen;
  }
}

export class ResultMessages {
  public static ORDER_ENUM_FETCH_ISSUE = 'Error retrieving OrderStatus';
  public static RESULT_FETCH_ISSUE = 'Error retrieving Results';
  public static LINKED_ACCOUNT_FETCH_ISSUE = 'Error retrieving Linked Account for selected BU';
  public static RESULTS_ROUTE = 'results';
  public static EDIT_DEMOGRAPHIC_ROUTE = 'results/edit-demographic';
}

export class SessionMessage {
  public static SNACKBAR_MESSAGE = `Your session is about to expire, click "Extend" to extend your session.
   You will be automatically logged out in`;
  public static SNACKBAR_AUTO_LOGOFF_MESSAGE = 'Your session has been inactive for X minutes. You have been automatically logged off for security reasons. Please log on to continue using LabPort.';
  public static SNACKBAR_LOGOFF_TIMER_MESSAGE = 'Your session is about to expire due to inactivity. You will be automatically logged off in X mm:ss.';
}

export class ShareReport {
  public static emailSuccess = 'Report shared successfully by email.';
  public static emailError = 'Error sharing the report by email.';
  public static faxSuccess = 'Share report by fax request has been submitted successfully.';
  public static faxError = 'Error sharing the report by fax.';
}

export class UpdatePassword {
  public static CURRENT_PASSWORD_REQUIRED = 'Current Password is mandatory';
  public static NEW_PASSWORD_REQUIRED = 'New Password is mandatory';
  public static CONFIRM_NEW_PASSWORD_REQUIRED = 'Confirm New Password is mandatory';
  public static UNMATCHED_PASSWORD = 'Please enter matching passwords.';
  public static PWD_POLICY_ERROR = 'Your passwords do not meet the password policy requirements.';
  public static WRONG_PASSWORD_ERROR = 'Your current password is incorrect.';
  public static WRONG_PASSWORD_SERVER_ERROR = 'Old password is incorrect.';
  public static SUCCESS_MESSAGE = 'Your password has been successfully updated.';
}

export class PasswordPolicy {
  public static LENGTH_REQUIREMENT = 'At least 15 characters';
  public static UPPERCASE_REQUIREMENT = 'At least one upper case character';
  public static LOWERCASE_REQUIREMENT = 'At least one lower case character';
  public static NUMERIC_REQUIREMENT = 'At least one numerical digit';
  public static SPECIAL_CHARACTER_REQUIREMENT = 'At least one special character';
  public static CHARACTER_LIST_1 = '! @ # $ % ^ & * - _ + = [ ] { } |';
  public static CHARACTER_LIST_2 = ' \\ : ‘ , . ? / ` ~ “ ( ) ;';
}

export class EditDemographicForm {
  public static PATIENT_LASTNAME_MAXLENGTH = 'Max length for Patient Last Name is 50.';
  public static PATIENT_LASTNAME_REQUIRED = 'Patient Last Name is mandatory.';
  public static PATIENT_FIRSTNAME_MAXLENGTH = 'Max length for Patient First Name is 50.';
  public static PATIENT_FIRSTNAME_REQUIRED = 'Patient First Name is mandatory.';
  public static PATTIENT_DOB_INCORRECTDATE = 'Patient DOB must be less than or equal to the current date';
  public static COLLECTED_ON_INCORRECTDATE = 'Collected On must be less than or equal to the current date';
  public static INVALID_DATE_FORMAT = 'Please enter date in MM/DD/YYYY format.';
  public static USER_CHANGES_SAVED = 'User changes are saved successfully';
  public static PATIENT_DOB_REQUIRED = 'Patient DOB is mandatory.';
  public static COLLECTED_ON_REQUIRED = 'Collected On is mandatory.';
}

export class DynamicForm {
  public static INVALID_DATE_FORMAT = 'Please enter date in MM/DD/YYYY format.';
  public static ENTER_VALID = 'Please enter valid date';
  public static readonly MIN_DOB_DATE_VALIDATION = 'Date must be greater than 01/01/1901'
}

export class GenerateReport {
  public static FILE_NOT_PRESENT_ERROR_MESSAGE = 'Report not available.';
  public static FILE_CANT_DOWNLOAD_ERROR_MESSAGE = 'Unable to download report.';
  public static NEWREPORT_CALL = 'Report is being generated for ';
  public static NEWREPORT_RECEIVED = 'New report is available now for ';
  public static NEWREPORT_CALL_FAILED = 'We are unable to process your request, please try after some time.';
  public static GENERATE_NEW_REPORT_NOTE = 'Note: Report generation may take a few moments.';
  public static GENERATE_NEW_REPORT_ERROR = 'Error retrieving Report';
  public static DISMISS = 'Dismiss';
  public static GENERATE_NEW_REPORT_DEBOUNCE_COUNT = 30000;
  public static GENERATE_NEW_REPORT_TO_BE_REFRESHED = 10;
  public static SELECTALL_INFO_MESSAGE = 'Top 25 reports on this page are selected.';
  public static MAX_SELECTION_INFO_MESSAGE = 'Maximum selection allowed is 25.';
  public static CONSOLIDATED_REPORT_DOWNLOADING_MESSAGE = 'Your consolidated report is downloading.';
  public static REPORT_READY_DOWNLOAD_MESSAGE = 'Your report is ready to download';
  public static CLICK_HERE = 'Click Here';
  public static readonly ERROR_OCCURED_WHILE_MERGING = 'Error occurred while merging reports';
  public static REPORT_READY_BUT_NOT_ALL_REPORTS_AVAILABLE = 'Your report is ready to download but not all the reports are available';
  public static EEROR_RETRIEVING_MERGED_REPORTS = 'Error retrieving merged reports';

}
export class CancelOrder{
  public static readonly CANCEL_ORDER_FAILURE = 'Error occurred when sending email.';
  public static readonly CANCEL_ORDER_SUCCESS = 'Cancellation Request email sent successfully.';
}

export class UpdateOrderDisplayMessage{
  public static readonly UPDATE_ORDER_FAILURE = 'Error occurred when sending email.';
  public static readonly UPDATE_ORDER_SUCCESS = 'Order update Request email sent successfully.';
}

export class DatePicker {
  public static INVALID_DATE = 'Please enter DOB in MM/DD/YYYY format.';
  public static GREATER_DATE = 'DOB cannot be a future date';
}

export class AcknowledgementDialog {
  public static errorMesage = 'Entered name does not match logged-on user\'s name.';
  public static maxLength = 'Max Length is Achieved';
  public static requiredMessage = 'Acknowledgement is mandatory';
  public static DialogText = 'Acknowledge';
  public static Warning = 'Something went wrong, Try again.';

}

export class OrderMessages {
  public static ACCOUNT_SELECTED = 'AccountSelected';
  public static readonly ACCOUNT_CLEARED = 'AccountCleared';
  public static readonly PATIENT_DETAILS_SELECTED = 'PatientDetailsSelected';
  public static readonly VIR_ACCOUNT_SELECTED = 'VirAccountSelected';
  public static readonly BU_SET = 'BuSet';
  public static CLOSE_ORDER = 'CloseOrder';
  public static PHYSICIAN_SELECTED = 'PhysicianSelected';
  public static PATIENT_SELECTED = 'PatientSelected';
  public static REDIRECT_FROM_ACCOUNT = 'RedirectFromAccount';
  public static REDIRECT_FROM_PHYSICIAN = 'RedirectFromPhysician';
  public static REDIRECT_FROM_INSURANCE = 'RedirectFromInsurance';
  public static requiredMessageAccount = 'Account is mandatory';
  public static readonly requiredFirstName = FIRST_NAME_REQUIRED;
  public static readonly requiredLastName = LAST_NAME_REQUIRED;
  public static requiredNPINumber = 'NPI Number is mandatory';
  public static formatNPINumber = 'NPI number format is incorrect';
  public static requiredMessagePhysician = 'Ordering physician selection is mandatory';
  public static requiredMessageReferringPhysician = 'selection is mandatory';
  public static selectAccount = 'Select Account';
  public static selectPhysician = 'Select Ordering physician or Search by Name or NPI';
  public static selectPhysicianAccountScreen = 'Search physician by Name or NPI';
  public static selectReferringPhysician = 'Select Referring physician or Search by Name or NPI';
  public static ENTER_DETAILS_MANUALLY = "Enter Details Manually";
  public static readonly AddPhysician = 'Add Physician';
  public static readonly INSURANCE_ENTER_DETAILS_MANUALLY = "Enter Payor Details";
  public static SEARCH_BY_NPI = 'Search Physician By Name or NPI';
  public static REQUIRED_SUBSCRIBERID = 'Policy number is mandatory';
  public static typeOfIdentifierRequired = 'Type of identifier is mandatory';
  public static identifierIssuingStateCodeRequired = 'Identifier issuing state is mandatory';
  public static identifierValueRequired = 'Identifier value is mandatory';
  public static SEARCH_BY_PATIENT = 'Search Patient by Name or ID';
  public static PURCHASE_ORDER_DETAIL = 'purchase-order/purchase-order-detail';
  public static PURCHASE_ORDER = 'purchase-order';
  public static SELECT_PAYOR = 'Search Payor by Name or ID';
  public static readonly ADD_PATIENT_MANUALLY = 'Add Patient';

}

export class InsuranceMessage {
  public static SELECTPAYOR = 'Select Payor';
  public static CLOSE_ORDER = 'CloseOrder';
  public static REQUIREDMESSAGEPAYOR = 'Payor selection is mandatory';
  public static RELATION_REQUIRED = 'Relation is mandatory';
  public static GROUP_REQUIRED = 'Group is mandatory';
  public static REFERRAL_REQUIRED = 'Referral Authorization is mandatory';
  public static SUBSCRIBER_REQUIRED = 'Subscriber Id is mandatory';
  public static readonly FIRSTNAME_REQUIRED = FIRST_NAME_REQUIRED;
  public static readonly LASTNAME_REQUIRED = LAST_NAME_REQUIRED;
  public static FETCH_INSURANCE_DETAILS_FAILURE_MESSAGE = 'Fetching insurance details failed';
  public static PAYOR_NAME_LENGTH = 'Max length for payor name is 50';
  public static readonly ACCOUNT_REQUIRED = 'Please select an account to add insurance details.';
}

export class GenericMessage {
  public static GENERAL_FAILURE_MESSAGE = 'Internal server error. Please check after sometime.';
}
export class EmailNotificationMessage {
  public static EMAIL_NOTIFICATION_MESSAGE = 'Email subscription updated successfully';
}

export class CreateEditAnnouncementMessage {
  public static Validations = {
    TITLE_REQUIRED: 'Title is mandatory',
    PUBLISH_FROM_REQUIRED: 'Publish from date is mandatory',
    PUBLISH_TO_REQUIRED: 'Publish to date is mandatory',
    BU_REQUIRED: 'BU(s) is mandatory',
    DISPLAY_OPTIONS: 'Display option(s) is mandatory',
    PUBLISH_FROM_MIN_DATE: 'The date cannot be before ',
    PUBLISH_TO_MIN_DATE: 'The date cannot be before Publish From Date',
    INVALID_DATE_FORMAT: INVALID_DATE_FORMAT,
    GENERAL_FAILURE: GENERAL_FAILURE,
    ANNOUNCEMENT_MESSAGE_REQUIRED: 'Announcement Message is mandatory'
  };

  public static ReturnValidations() {
    return this.Validations;
  }
}
export class OrderPatientFormErrorMessages {
  public static PROJECT_REQUIRED = 'Project is mandatory';
  public static PATIENT_ID_REQUIRED = 'Patient ID is mandatory';
  public static PATIENT_SELECT_REQUIRED = 'Patient Selection is mandatory';
  public static readonly FIRST_NAME_REQUIRED = FIRST_NAME_REQUIRED;
  public static readonly LAST_NAME_REQUIRED = LAST_NAME_REQUIRED;
  public static PATIENT_DOB_REQUIRED = 'Date Of Birth is mandatory';
  public static PATIENT_DOB_INCORRECTDATE = 'Patient DOB must be less than or equal to the current date';
  public static PATIENT_TRANSPLANT_DATE_INCORRECT = 'Patient Transplant Date must be less than or equal to the current date'
  public static readonly INVALID_DATE_FORMAT = INVALID_DATE_FORMAT;
  public static GENDER_REQUIRED = 'Gender is mandatory';
  public static ADDRESS_LINE1_REQUIRED = 'Address Line 1 is mandatory';
  public static CITY_REQUIRED = 'City is mandatory';
  public static ZIPCODE_REQUIRED = 'Zip Code is mandatory';
  public static ZIPCODE_FORMAT = ' Zip Code format is incorrect';
  public static readonly ZIPCODE_MAX_LENGTH = ' Max length for Zip Code is 10';
  public static STATE_REQUIRED = 'State is mandatory';
  public static readonly STATE_MAX_LENGTH = 'Max length for State is 30';
  public static COUNTRY_REQUIRED = 'Country is mandatory';
  public static readonly COUNTRY_MAX_LENGTH = 'Max length for Country is 50';
  public static PHONE1_REQUIRED = 'Phone1 is mandatory';
  public static readonly PHONE_FORMAT = PHONE_FORMAT;
  public static PHONE_REQUIRED = 'Phone is mandatory';
  public static PHONE1_FORMAT = 'Phone1 format is incorrect';
  public static PHONE2_FORMAT = 'Phone2 format is incorrect';
  public static readonly EMAIL_REQUIRED = EMAIL_IS_MANDATORY;
  public static readonly EMAIL_FORMAT = EMAIL_FORMAT_INCORRECT;
  public static PATIENT_RACE_REQUIRED = 'Race is mandatory';
  public static PATIENT_ETHNICITY_REQUIRED = 'Ethnicity is mandatory';
  public static ICD_CODE_REQUIRED = 'ICD10 code selection is mandatory';
  public static readonly LINKED_ACCOUNT_REQUIRED = ACCOUNT_SELECTION_IS_MANDATORY;
  public static readonly GENERAL_FAILURE = GENERAL_FAILURE;
  public static readonly NO_RECORDS_FOUND = NO_RECORDS_FOUND;
  public static SUCCESS_PATIENT_CREATION = 'Patient Created Successfully';
  public static SUCCESS_PATIENT_UPDATED = 'Patient Updated Successfully';
  public static EMAIL_ALREADY_EXIST = 'Email already exists in our system.';
  public static ACCOUNT_DIFFER = 'Patient cannot be edited if shared between multiple accounts that you dont have access to';
  public static readonly ACCOUNT_REQUIRED = ACCOUNT_SELECTION_IS_MANDATORY;
  public static STATUS_REQUIRED: 'Status is mandatory';
  public static EMAIL_EXISTING = 'Emai ID already exist';
  public static PREFERRED_COMMUNICATION_REQUIRED = 'Please select preferred method of communication'
  public static EMAIL_EXISTING_WITH_DIFFERENT_BU =
    'This email is associated with different account that you don\'t have access to. Please use different email ID';
  public static PROJECT_FOR_CHILD_PROFILES = 'Project only for child profiles';
  public static PATIENT_NOT_ENROLLED = 'Patient not enrolled to the project';
  public static readonly ACCOUNT_CODE_DIFFERENT_PRACTICE = 'Sorry! Cannot map a patient to multiple practices.';
  public static readonly ACCOUNT_BUCODE_DIFFERENT ='Patient cannot be mapped to multiple BUs.';
  public static readonly PATIENT_MIN_DOB_DATE ='Date must be greater than 01/01/1901';
  public static readonly PREVENT_PATIENT_UPDATE = 'Patient information cannot be updated';
  public static readonly PARENT_CHILD_DONOR_REQUIRED = 'Is donor parent or child of the patient is mandatory';
}
export class ReferringPhysicianMessage {
  public static readonly FIRST_NAME_REQUIRED = FIRST_NAME_REQUIRED;
  public static NPI_NUMBER_REQUIRED = 'NPI Number is mandatory';
  public static NPI_NUMBER_FORMAT = 'NPI Number format is incorrect';
  public static CITY_REQUIRED = 'City is mandatory';
  public static ADDRESS_LINE1_REQUIRED = 'Address Line1 is mandatory';
  public static ZIP_CODE_REQUIRED = 'Zip Code is mandatory';
  public static STATE_REQUIRED = 'State is mandatory';
  public static COUNTRY_REQUIRED = 'Country is mandatory';
  public static FAX_REQUIRED = 'Fax Number is mandatory';
  public static readonly EMAIL_REQUIRED = EMAIL_IS_MANDATORY;
  public static ZIPCODE_FORMAT = ' Zip Code format is incorrect';
  public static readonly PHONE1_FORMAT = PHONE_FORMAT;
  public static FAX_FORMAT = 'Fax format is incorrect';
  public static readonly EMAIL_FORMAT = EMAIL_FORMAT_INCORRECT;
}

export class SpecimenTypeMessages {
  public static SPECIMEN_TYPE_ROUTE = './';
}

export class CreateQuestionErrors {
  public static readonly BU_REQUIRED = BU_IS_MANDATORY;
  public static BUQUESTION_CODE = 'BU question code is mandatory';
  public static readonly SELECT_ACCOUNTS = ACCOUNT_SELECTION_IS_MANDATORY;
  public static QUESTION = 'Question is mandatory';
  public static ISMANDATORY = 'Value is mandatory';
  public static readonly STATUS = STATUS_IS_MANDATORY;
  public static FIELDTYPE = 'Field type is mandatory';
  public static MAXLENGTH = 'Maxlength is mandatory';
  public static RANGEMIN = 'Min is mandatory';
  public static RANGEMAX = 'Max is mandatory';
  public static CHOSELIST = 'Choice list is mandatory';
  public static SELECTIONTYPE = 'Selection type is mandatory';
  public static BU_QUESTIONCODE = 'BU question code already exists in our system.';
  public static readonly NO_RECORDS_FOUND = NO_RECORDS_FOUND;
  public static MINLESSTHANMAX = 'Min should be less than Max';
  public static MAXGREATERTHANMIN = 'Max should be greater than Min';
  public static MAXLENGTHCANNOTBEZERO = 'Max length value should be a positive number';
  public static OPTION_CODE_MANDATORY = 'Option code is mandatory';
  public static OPTION_TITLE_MANDATORY = 'Option title is mandatory';
  public static QUESTION_MAP_MESSAGE = 'Question is already selected with other Option Code';
  public static GENERAL_FAILURE = 'Something went wrong, please try again';

}

export class PayorFormErrors {
  public static readonly BU_REQUIRED = BU_IS_MANDATORY;
  public static readonly PAYORID_REQUIRED = 'Payor ID is mandatory';
  public static readonly CATEGORY_REQUIRED = 'Category is mandatory';
  public static readonly SELECT_ACCOUNTS = ACCOUNT_SELECTION_IS_MANDATORY;
  public static readonly PAYOR_NAME = 'Payor Name is mandatory';
  public static readonly ISMANDATORY = 'Value is mandatory';
  public static readonly STATUS = STATUS_IS_MANDATORY;
  public static readonly FIELDTYPE = 'Field type is mandatory';
  public static readonly MAXLENGTH = 'Maxlength is mandatory';
  public static readonly RANGEMIN = 'Min is mandatory';
  public static readonly RANGEMAX = 'Max is mandatory';
  public static readonly CHOSELIST = 'Choice list is mandatory';
  public static readonly SELECTIONTYPE = 'Selection type is mandatory';
  public static readonly BU_QUESTIONCODE = 'BU question code already exists in our system.';
  public static readonly NO_RECORDS_FOUND = NO_RECORDS_FOUND;
  public static readonly MINLESSTHANMAX = 'Min should be less than Max';
  public static readonly MAXGREATERTHANMIN = 'Max should be greater than Min';
  public static readonly MAXLENGTHCANNOTBEZERO = 'Max length value should be a positive number';
  public static readonly OPTION_CODE_MANDATORY = 'Option code is mandatory';
  public static readonly OPTION_TITLE_MANDATORY = 'Option title is mandatory';
  public static readonly QUESTION_MAP_MESSAGE = 'Question is already selected with other Option Code';
  public static readonly GENERAL_FAILURE = 'Something went wrong, please try again';
  public static readonly PAYORID_MAXLENGTH = 'Max 20 characters are allowed';
  public static readonly PAYOR_NAME_MAXLENGTH = 'Max 50 characters are allowed';
  public static readonly PAYOR_GROUP_MAXLENGTH = 'Max 50 characters are allowed';
  public static readonly MAXLENGTH_100 = 'Max 100 characters are allowed';
  public static readonly MAXLENGTH_30 = 'Max 30 characters are allowed';
  public static readonly MINLENGTH_5 = '5 numbers are mandatory';
  public static readonly MINLENGTH_10 = '10 numbers are mandatory';
  public static readonly PAYOR_ID_ALREADY_EXIST = "Payor ID already exists for this BU";
  public static readonly PAYOR_ID_ERROR_MESSAGE = 'Something went wrong while validating Payor Id, please try again';
  public static readonly PAYOR_EDIT_ERROR_MESSAGE = 'Something went wrong while updating, please try again';
}

export class BulkUploadDocuments {
  public static FILE_NOT_AVAILABLE = 'Template is not available';
  public static FILE_CANT_DOWNLOAD_ERROR_MESSAGE = 'Unable to download template.';
  public static FILE_UNABLE_TO_UPLOAD = 'Unable to upload template.';
  public static FILE_UNABLE_TO_VALIDATE = 'Unable to validate template.';
}

export class PackageManifestError {
  public static FILE_NOT_PRESENT_ERROR_MESSAGE = 'Package manifest not available.';
  public static FILE_CANT_DOWNLOAD_ERROR_MESSAGE = 'Unable to download package manifest.';
  public static FILE_CANT_PRINT_ERROR_MESSAGE = 'Unable to print package manifest.';
}

export class RequisitionManifestError {
  public static FILE_NOT_PRESENT_ERROR_MESSAGE = 'Requisition manifest not available.';
  public static FILE_CANT_DOWNLOAD_ERROR_MESSAGE = 'Unable to download requisition manifest.';
  public static FILE_CANT_PRINT_ERROR_MESSAGE = 'Unable to print requisition manifest.';
}

export class CreateEditManageProjectMessage {
  public static Validations = {
    REQUIRED_DATE_FORMAT: INVALID_DATE_FORMAT,
    PROJECTNAME_REQUIRED: 'Project Name is mandatory',
    PROJECTTYPE_REQUIRED: 'Project Type is mandatory',
    PERFORMINGLAB_REQUIRED: 'Performing Lab Selection is mandatory',
    PROJECT_STARTDATE: 'Start Date is mandatory',
    ACCOUNT: ACCOUNT_SELECTION_IS_MANDATORY,
    PHYSICIANNAMENPI: 'Ordering Physician selection is mandatory',
    TEST: 'Test Selection is mandatory',
    START_DATE_MIN: 'The date cannot be before ',
    END_DATE_MIN: 'The date cannot be before Publish From Date',
    INVALID_DATE_FORMAT: INVALID_DATE_FORMAT,
    BILLING_TYPE: 'Billing type selection is mandatory',
    SAMPLE_COLLECTION_TYPE: 'Collection Type selection is mandatory',
    ACCESSCODE_REQUIRED: 'Access Code is mandatory',
    ACCESSCODE_UNIQUE: 'Access Code must be unique',
    CONSENTFORM_MESSAGE_REQUIRED: 'Consent form is mandatory',
    START_DATE_SHOULDBE_GREATER_THAN_CURRENT: 'Start Date should be greater than or equal to current date',
    END_DATE_SHOULDBE_GREATER_THAN_SD: 'End Date should be greater than start date',
    SCHEDULE_START_DATE_REQUIRED: 'Start date is mandatory',
    SCHEDULE_END_DATE_REQUIRED: 'End date is mandatory',
    SCHEDULE_SLOT_LENGTH_REQUIRED: 'Slot length is mandatory',
    SCHEDULE_SLOT_CAPACITY_REQUIRED: 'Capacity per slot is mandatory',
    SCHEDULE_SLOT_CAPACITY_NON_ZERO: 'Capacity per slot cannot be 0 or less',
    SCHEDULE_START_DATE_SHOULDBE_GREATER_THAN_CURRENT: 'Start Date should be greater than or equal to present date',
    SCHEDULE_START_DATE_SHOULDBE_GREATER_THAN_PRJ_SD: 'Start Date should be greater than or equal to project start date',
    SCHEDULE_START_DATE_SHOULDBE_GREATER_THAN_PRJ_ED: 'Start Date should be less than or equal to project end date',
    SCHEDULE_EXCLUDED_DATE_RANGE_ERROR: 'Excluded date should be between schedule start and end dates',
    SCHEDULE_END_DATE_SHOULDBE_GREATER_THAN_PRJ_SD: 'End Date should be greater than or equal to scheduler start date',
    SCHEDULE_END_DATE_SHOULDBE_GREATER_THAN_PRJ_ED: 'End Date should be less than or equal to project end date'
  };
  public static ReturnValidations() {
    return this.Validations;
  }
}

export class CreateUpdateTestFormError {
  public static Validations = {
    BU_REQUIRED: BU_IS_MANDATORY,
    BU_TESTCODE_MANDATORY: 'BU Test Code is mandatory',
    BU_TESTCODE_MAXLENGTH: 'Max length for BU Test Code is 50',
    BU_TESTCODE_UNIQUE: 'BU Test code already exists in our system',
    BU_PANELCODE_MANDATORY: 'BU Panel Code is mandatory',
    BU_PANELCODE_MAXLENGTH: 'Max length for BU Panel Code is 50',
    BU_PANELCODE_UNIQUE: 'BU Panel code already exists in our system',
    BU_TEST_CODE_REQUIRED: 'Test codes are required',
    TEST_LINKED_ACCOUNTS_REQUIRED: 'Linked Accounts are required',
    TEST_NAME_MANDATORY: 'Test name is mandatory',
    TEST_NAME_MAX_LENGTH: 'Max length for test name is 50',
    CHOOSE_APPLICABLE_SPECIMENS: 'Applicable specimen list is mandatory',
    NO_RECORDS_FOUND: NO_RECORDS_FOUND,
    NO_TEST_FOUND: 'No tests found for selected BU.',
    GENERAL_FAILURE: GENERAL_FAILURE,
    TEST_LINKED_LABSITES_REQUIRED: 'BU Facilities are required.',
    PHYSICIAN_APPROVAL_MANDATORY: 'Physician approval is mandatory.',
    CONSENT_MANDATORY: 'Consent is mandatory.',
    COLLECTION_TYPE_MANDATORY: 'Select collection type.',
    DUPLICATE_SUBCONTRACT_BU: 'This BU cannot be selected as it has already been selected',
    SUBCONTRACT_TESTCODE_MANDATORY: 'Enter missing test detail under Performing BU.',
    SUBCONTRACT_PANELCODE_MANDATORY: 'Enter missing panel detail under Performing BU.',
    CONSENTFORM_MESSAGE_REQUIRED: 'Consent form is mandatory.',
    FILE_NOT_PRESENT_ERROR_MESSAGE: 'No attached instruction document is found.',
    FILE_CANT_DOWNLOAD_ERROR_MESSAGE: 'Instruction document cant be download.',
    PARAMETER_ERROR_MESSAGE: 'upload a valid parameters list',
    UPLOAD_PARAMETER_FAILURE: 'Failed to upload parameters',
    SPECIMENSSAMPLETYPE__MAXLENGTH: 'Max length for Sample Type is 50',
    SPECIMENSSAMPLETYPE__MANDATORY: 'Sample Type is mandatory',
    SPECIMENSCONTAINERTYPE__MANDATORY: 'Container Type is mandatory',
    SPECIMENSTORAGETYPE__MANDATORY: 'Storage Type is mandatory',
    SPECIMENSCONTAINERTYPE__MAXLENGTH: 'Max length for Container Type is 50',
    SPECIMENSTORAGETYPE__MAXLENGTH: 'Max length for Storage Type is 50',
    SPECIMENCONTAINERCOUNT_INVALID_NUMBER: 'Container count cannot be more than 999',
    SPECIMENSPECIALINSTRUCTIONS__MAXLENGTH: 'Max length for Special Instructions is 2000',
  };
  public static ReturnValidations() {
    return this.Validations;
  }
}

export class CreateUpdateAccountFormError {
  public static Validations = {
    BU_REQUIRED: BU_IS_MANDATORY,
    ACCOUNT_NAME_MANDATORY: 'Account name is mandatory',
    ACCOUNT_NAME_MAX_LENGTH: 'Max length for account name is 100',
    BU_ACCOUNT_CODE_MANDATORY: 'BU Account code is mandatory',
    BU_ACCOUNT_CODE_MAX_LENGTH: 'Max length for bu account code is 50',
    BU_ACCOUNT_CODE_UNIQUE: 'BU Account code already exists in our system',
    PHONE_FORMAT: PHONE_FORMAT,
    EMAIL_FORMAT: EMAIL_FORMAT_INCORRECT,
    FAX_FORMAT: 'Fax format is incorrect',
    PHYSICIAN_REQUIRED: 'Physician selection is mandatory',
    NO_RECORDS_FOUND: NO_RECORDS_FOUND,
    SALES_BU_REQUIRED: 'Sales BU is mandatory',
    FAILED_TO_LOAD: 'Failed to load account. Please try again.',
    PRACTICEID_REQUIRED: 'Practice ID is mandatory',
  };
  public static ReturnValidations() {
    return this.Validations;
  }
}

export class SendPackageDialogError {
  public static Validations = {
    TRACKING_ID_MAX_LENGTH: 'Max length for tracking id is 40',
    TRACKING_ID_PATTERN: 'Semi-colon is not allowed',
  }

  public static ReturnValidations() {
    return this.Validations;
  }
}

export class CreateUpdatePackageFormError {
  public static Validations = {
    PACKAGE_ACCOUNT_REQUIRED: 'Package Account is mandatory',
    ORDER_ACCOUNT_REQUIRED: 'Order Account is mandatory',
    TRACKING_ID_MAX_LENGTH: 'Max length for tracking id is 40',
    TRACKING_ID_PATTERN: 'Semi-colon is not allowed',
    SHIPPER_TYPE_REQUIRED: 'Shipper Type is mandatory',
    REQUEST_TYPE_REQUIRED: 'Request Type is mandatory',
    RECEIVING_LAB_REQUIRED: 'Receiving Lab is mandatory',
    INVALID_DATE_SPECIMENS: 'Please correct the date time entered for the specimens highlighted',
    PACKAGEID_REQUIRED: 'Package Id is mandatory',
    PACKAGEID_DOES_NOT_EXISTS: 'The Package ID does not exist',
    PACKAGE_NOT_IN_CURRENT_STAT: 'The Package is not in Current Status',
    PACKAGEACC_DOES_NOT_BELONG_TO_USER: 'Sorry! you are not authorized to create orders for account '
  };

  public static ReturnValidations() {
    return this.Validations;
  }
}

export class OrderFormComponentErrorMessages {
  public static Validations = {
    INVALID_DATE_SPECIMENS: 'Please correct the date time entered for the specimens highlighted',
    ERROR_SPECIMEN_NOT_ADDED: 'Please add atleast one specimen to create an order.',
    ERROR_ORDER_VALIDATION_MSG: 'Please fill-in mandatory fields to submit the order.'
  };
  public static ReturnValidations() {
    return this.Validations;
  }
}

export class AddOrderPackageFormError {
  public static Validations = {
    ACCOUNT_REQUIRED: 'Order Account is mandatory',
    REQUEST_TYPE_REQUIRED: 'Request Type is mandatory',
  };

  public static ReturnValidations() {
    return this.Validations;
  }
}

export class ExportDocumentErrors {
  public static readonly FILE_NOT_PRESENT_ERROR_MESSAGE = "File not available.";
  public static readonly FILE_CANT_OPEN_ERROR_MESSAGE = "Unable to Open LMN Document.";
}

export class UpdateOrderRequestErrors{
  public static readonly Validations = {
  MAX_500_CHARACTERS : "Max 500 characters are allowed"
  }

  public static ReturnValidations() {
    return this.Validations;
  }
}

export class PRNOrderValidationMessages {
  public static readonly MAX_25_ORDERS = "Max. 25 provisional orders can be created.";
  public static readonly PRN_DATE_REQUIRED = "Provisional order date is required";
  public static readonly DATE_MUST_BE_GREATER_THAN_PREVIOUS_DATE = "Provisional order date must be greater than the previous provisional order date";
  public static readonly ATLEAST_ONE_PRN_DATE_REQUIRED = "At least one Provisional order date is required along with current order date.";
  public static readonly DATE_MUST_BE_WITHIN_START_AND_END_DATE = "Provisional order dates must be within Start Date and End Date for the SO";
  public static readonly START_DATE_AND_END_DATE_REQUIRED = "Start Date and End Date are mandatory to set the provisional dates for standing orders";
}

